// @ts-nocheck
/* eslint-disable */
import { CONFIG } from "~/config";
import { frpc } from "~/util/general";

(function() {
	const URL = "/mediarpc/";

	Mapy.ProviderPhotos = {};
	/**
	 * Dotaz na galerii autora
	 * @param {Array} opts volby [limit, offset, {ratios, authorId, orderby}]
	 * @return {Object}
	 */
	Mapy.ProviderPhotos.authorGalleryGet = args => {
		return frpc({
			url: CONFIG.requestUrl + URL,
			method: "author.gallery.get",
			args,
		});
	}

	/**
	 * Vraci informace o autorovi pokud existuje
	 * @return {JAK.Promise}
	 */
	Mapy.ProviderPhotos.authorInfoGet = () => {
		return frpc({
			url: CONFIG.requestUrl + URL,
			method: "author.info.get",
		}).promise;
	}
	/**
	 * Vraci timestamp schválení licenčního ujednání uživatele
	 * @return {JAK.Promise}
	 */
	Mapy.ProviderPhotos.authorLicenseGet = () => {
		return frpc({
			url: CONFIG.requestUrl + URL,
			method: "author.license.get",
		}).promise;
	}
	/**
	 * slouzi k odmazani media mediaserveru
	 * @param {Number} id Id média
	 * @return {JAK.Promise}
	 */
	Mapy.ProviderPhotos.mediaDel = (id, isFirmPhoto) => {
		let args = [id];
		if (isFirmPhoto) {
			args.push("firm");
		}

		return frpc({
			url: CONFIG.requestUrl + URL,
			method: "media.del",
			args,
		}).promise;
	}

	/**
	 * Vrati data o mediu
	 * @param {Number} id Id média
	 * @return {JAK.Promise}
	 */
	Mapy.ProviderPhotos.mediaGet = id => {
		return frpc({
			url: CONFIG.requestUrl + URL,
			method: "media.get",
			args: [id, {ratios:["original","default","16x9"]}],
		}).promise;
	}
})();
